module.exports = __webpack_public_path__ + "img/32c6178f19886260022650e17c112525.png";